<template>
  <div class="author"></div>
</template>

<script>
import { mapGetters } from 'vuex'
import { getRedirect } from '@/utils/index'

export default {
  name: 'Author',
  components: {
  },
  computed: {
    ...mapGetters([
      'clazzShareUser',
      'clazzShareId'
    ])
  },
  data () {
    return {
    }
  },
  created () {
    if (!this.$route.query.code) {
      this.redirectWx()
    } else {
      this.getUserInfo()
    }
  },
  methods: {
    redirectWx () {
      const appid = 'wxfa04f845d73c70b8'
      const scope = 'snsapi_userinfo'
      const redirectUrl = window.location.href
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${redirectUrl}&response_type=code&scope=${scope}&state=STATE#wechat_redirect`
    },
    async getUserInfo () {
      const code = this.$route.query.code
      let redirectUrl = window.location.href.split('?')[0]
      await this.$store.dispatch('LoginByWx', {
        'code': code,
        'redirect_uri': redirectUrl,
        'share_from': {
          'user': this.clazzShareUser,
          'clazz': this.clazzShareId
        }
      })
      this.$router.push({ path: getRedirect() || '/' })
    }
  }
}
</script>

<style scoped lang="scss">
</style>
